import { render } from "./Parcel.vue?vue&type=template&id=2dffe6e4&scoped=true"
import script from "./Parcel.vue?vue&type=script&lang=js"
export * from "./Parcel.vue?vue&type=script&lang=js"

import "./Parcel.vue?vue&type=style&index=0&id=2dffe6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dffe6e4"]])

export default __exports__